<template>
  <div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-data-table
          class="text-center"
          :apiMode="true"
          :apiUrl="apiUrl"
          :httpOptions="httpOptions"
          :defaultPerPage="defaultTablePerPage"
          :tableFields="tableFields"
          :perPageSelectorShown="false"
          :actions="false"
          :filterInputShown="false"
        ></vuestic-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import StatusColumn from './helpers/status-column'
import PaymentColumn from './helpers/payment-column'
Vue.component('status-column', StatusColumn)
Vue.component('payment-column', PaymentColumn)

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    StatusColumn,
    // eslint-disable-next-line vue/no-unused-components
    PaymentColumn
  },
  data() {
    return {
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      apiUrl: `${process.env.VUE_APP_WEBSITE_URL}packages/api/v1/Subscription/client/invoice/list?online=true`,
      tableFields: [
        {
          name: '__sequence',
          dataClass: 'text-light'
        },
        {
          name: 'number',
          title: 'Number'
        },
        {
          name: 'date',
          title: 'Date'
        },
        {
          name: 'email',
          title: 'Email'
        },
        {
          name: 'total',
          title: 'Amount'
        },
        {
          name: 'currency_code',
          title: 'Currency'
        },
        {
          name: '__component:status-column',
          title: 'Status'
        },
        {
          name: '__component:payment-column',
          title: ''
        }
      ],
      defaultTablePerPage: 10
    }
  }
}
</script>
